// @ts-strict-ignore
import { Service } from 'rainbow-web-sdk/services/service';
import { Subject, from } from 'rxjs';

export const EVENT_SVC = 'EventService';

/**
 * Collection of Rainbow global events.
 *
 * @public
 */
export enum EventServiceEvents {

    /**
     * This event is fired when Rainbow App needs to open a window popup and that user has blocked the popup usage.
     * This event is generally used to display an information message.
     */
    RAINBOW_APP_NEEDS_POPUP = 'RAINBOW_APP_NEED_POPUP',
    TOAST = 'RAINBOW_TOAST'
}

export class EventService extends Service {

    private $rootScope: any = null;

    private rxSubject: Subject<any> = new Subject<any>();
    private listeners: any = {};
    private events: any;

    public static getInstance() {
        return Service.create(EVENT_SVC, EventService);
    }

    public static build() {
        return new EventService();
    }

    private constructor() {
        super();
        this.events = from(this.rxSubject);

        // TO DO ADD try catch to make sure we do not break the subscriber
        this.events.subscribe(({ eventName, args }) => {
            if (this.listeners[eventName])
                for (const listener of this.listeners[eventName]) { listener(eventName, ...args); }
        });
    }

    public configure($rootScope: any = null) { this.$rootScope = $rootScope; }
    public subscribe(eventName: string, handler: any): any {
        if (!this.$rootScope) {
            if (!this.listeners[eventName]) this.listeners[eventName] = [];
            this.listeners[eventName].push(handler);
            return function tt(name: string, callback: any) {
                this.listeners[name] = this.listeners[name].filter((func: any) => func !== callback);
            }.bind(this, eventName, handler);
        }
        return this.$rootScope.$on(eventName, handler);
    }

    public unsubscribe(subscription: any): void { subscription(); }
    public publish(eventName: string, ...args: any[]): void {
        if (!this.$rootScope) this.rxSubject.next({ eventName, args });
        else this.$rootScope.$broadcast(eventName, ...args);
    }

    public setVariable(varName: string, value: string) {
        this.$rootScope[varName] = value;
    }

    public getVariable(varName: string) {
        return this.$rootScope[varName];
    }
}
